/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon16Regular = forwardRef('ArrowDUturnLeftDownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.25 7.5a5.75 5.75 0 1 1 11.5 0v3.75a.75.75 0 0 1-1.5 0V7.5a4.25 4.25 0 0 0-8.5 0v4.527l2.69-3.025a.75.75 0 1 1 1.12.996l-3.252 3.66a1.75 1.75 0 0 1-2.616 0L.439 9.997a.75.75 0 0 1 1.122-.996l2.689 3.025V7.5Z" })));
});
